import React, { useMemo } from "react";
import { useRecoilValue } from "recoil";

import Button from "components/button";
import useOverlay from "hooks/useOverlay";
import getInitials from "utils/getInitials";
import Modal from "components/modal";
import useClickToCall from "../useClickToCall";
import { getDerivedState, getPhoneImageUrl, getPhoneImageClassName, getStatusClassname } from "../utils";
import { ACTIVE_STATE_TYPES, CALL_STATUS_TYPES, clickToCallAtom } from "../constants";

import styles from "./callMaximizedView.scss";

export default function CallMaximizedView({ callBinded }) {
  const state = useRecoilValue(clickToCallAtom);
  const { dismiss, minimize } = useClickToCall();

  useOverlay(true);

  const { agentName, userName } = state;
  const { userStatus, agentStatus, message, duration, isActionButtonsShown } = getDerivedState(state);

  const agentInitials = useMemo(() => getInitials(agentName), [agentName]);
  const userInitials = useMemo(() => getInitials(userName), [userName]);

  const userStatusClassName = useMemo(() => getStatusClassname(userStatus), [userStatus]);
  const agentStatusClassName = useMemo(() => getStatusClassname(agentStatus), [agentStatus]);

  const phoneImageUrl = useMemo(() => getPhoneImageUrl(agentStatus, userStatus, ACTIVE_STATE_TYPES.CALL_MAXIMIZED), [agentStatus, userStatus]);
  const phoneImageClassName = useMemo(() => getPhoneImageClassName(agentStatus, userStatus), [agentStatus, userStatus]);

  const body = (
    <div className={styles.call_maximized_view}>
      {
        !(userStatus===CALL_STATUS_TYPES.ENDED && agentStatus===CALL_STATUS_TYPES.ENDED) &&
        <span onClick={minimize} className={styles.minimize_modal_container}>
          <span className={styles.minimize_modal}></span>
        </span>
      }
      <div className={styles.inside_call}>
        <div className={styles.caller_group}>
          <div className={`${styles.caller_profile} ${styles[agentStatusClassName]}`}>
            <div className={styles.caller}>
              <span className={styles.icon_text}>{agentInitials}</span>
            </div>
            {/* <div className={styles.call_status_text}>connected</div> */}
          </div>
          <div className={styles.call_icon_group}>
            <div className={`${styles.arrows_group} ${styles[agentStatusClassName]}`}>
              <span className={styles.arrow}></span>
              <span className={styles.arrow}></span>
            </div>
            <span className={`${styles.phone_icon} ${styles[phoneImageClassName]}`}>
                <img src={phoneImageUrl}  />
            </span>
            <div className={`${styles.arrows_group} ${styles.right} ${styles[userStatusClassName]}`}>
              <span className={styles.arrow}></span>
              <span className={styles.arrow}></span>
            </div>
          </div>
          <div className={`${styles.caller_profile} ${styles[userStatusClassName]}`}>
            <div className={styles.caller}>
              <span className={styles.icon_text}>
                {userInitials}
              </span>
            </div>
            {/* <div className={styles.call_status_text}>disconnected</div> */}
          </div>
        </div>
        <div className={styles.caller_info}>
          <p>{message}</p>
          {duration && <div className={styles.call_duration}>
            <small>{duration}</small>
          </div>}
        </div>
        {isActionButtonsShown && (
          <div className={styles.action_area}>
            <Button onClick={() => callBinded()} variant="outlinebtn">
              Call Again
            </Button>
            <Button onClick={dismiss}>
              Dismiss
            </Button>
          </div>
        )}
      </div>
    </div>
  );

  return <Modal body={body} onCloseClick={null} />;
}
